import { Icon } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const styles = makeStyles({
  iconComponent: {
    fontSize: (props) => `${props.fontSize} !important`,
    color: (props) => props.color,
    transform: (props) => props?.transform && "rotate(90deg)",
  },
});

const IconComponent = ({
  color,
  fontSize,
  iconLabel,
  transform = false,
  ...props
}) => {
  const classes = styles({ fontSize, color, transform, ...props });

  return (
    <Icon className={classes.iconComponent} {...props}>
      {" "}
      {iconLabel}{" "}
    </Icon>
  );
};

export default IconComponent;
